import {MarkType} from 'prosemirror-model';
import {EditorState} from 'prosemirror-state';

export const isMarked = (markType: MarkType) => (state: EditorState) => {
  return !!markType.isInSet(state.storedMarks || state.selection.$from.marks());
};
